export enum BotTypeEnum {
  DEFAULT = 'default',
  CHAT_FLOW = 'chat_flow',
}

export const BotTypeEnumLabels = {
  [BotTypeEnum.DEFAULT]: 'Padrão',
  [BotTypeEnum.CHAT_FLOW]: 'Fluxo de chat',
}